// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
export const TerminationCause = {
    TERMINATION_CAUSE_INVALID: 'TERMINATION_CAUSE_INVALID',
    TERMINATION_CAUSE_CALLER_HANGUP: 'TERMINATION_CAUSE_CALLER_HANGUP',
    TERMINATION_CAUSE_TIMEOUT: 'TERMINATION_CAUSE_TIMEOUT',
    TERMINATION_CAUSE_CARRIER_ERROR: 'TERMINATION_CAUSE_CARRIER_ERROR',
    TERMINATION_CAUSE_PROVIDER_ERROR: 'TERMINATION_CAUSE_PROVIDER_ERROR',
    TERMINATION_CAUSE_CONNECTION_ERROR: 'TERMINATION_CAUSE_CONNECTION_ERROR',
    TERMINATION_CAUSE_AI_HANGUP: 'TERMINATION_CAUSE_AI_HANGUP',
    TERMINATION_CAUSE_AI_TRANSFER: 'TERMINATION_CAUSE_AI_TRANSFER',
};
export const TerminationCauseValue = {
    TERMINATION_CAUSE_INVALID: 0,
    TERMINATION_CAUSE_CALLER_HANGUP: 1,
    TERMINATION_CAUSE_TIMEOUT: 2,
    TERMINATION_CAUSE_CARRIER_ERROR: 3,
    TERMINATION_CAUSE_PROVIDER_ERROR: 4,
    TERMINATION_CAUSE_CONNECTION_ERROR: 5,
    TERMINATION_CAUSE_AI_HANGUP: 6,
    TERMINATION_CAUSE_AI_TRANSFER: 7,
};
export const CallType = {
    CALL_TYPE_INVALID: 'CALL_TYPE_INVALID',
    CALL_TYPE_INBOUND: 'CALL_TYPE_INBOUND',
    CALL_TYPE_OUTBOUND: 'CALL_TYPE_OUTBOUND',
};
export const CallTypeValue = {
    CALL_TYPE_INVALID: 0,
    CALL_TYPE_INBOUND: 1,
    CALL_TYPE_OUTBOUND: 2,
};
export const CallSource = {
    CALL_SOURCE_INVALID: 'CALL_SOURCE_INVALID',
    CALL_SOURCE_PHONE: 'CALL_SOURCE_PHONE',
    CALL_SOURCE_BROWSER: 'CALL_SOURCE_BROWSER',
};
export const CallSourceValue = {
    CALL_SOURCE_INVALID: 0,
    CALL_SOURCE_PHONE: 1,
    CALL_SOURCE_BROWSER: 2,
};
export const Participant = {
    PARTICIPANT_INVALID: 'PARTICIPANT_INVALID',
    PARTICIPANT_FROM: 'PARTICIPANT_FROM',
    PARTICIPANT_TO: 'PARTICIPANT_TO',
};
export const ParticipantValue = {
    PARTICIPANT_INVALID: 0,
    PARTICIPANT_FROM: 1,
    PARTICIPANT_TO: 2,
};
export const VendorModel = {
    VENDOR_MODEL_UNSPECIFIED: 'VENDOR_MODEL_UNSPECIFIED',
    VENDOR_MODEL_OPEN_AI_REALTIME: 'VENDOR_MODEL_OPEN_AI_REALTIME',
    VENDOR_MODEL_DEEPGRAM: 'VENDOR_MODEL_DEEPGRAM',
};
export const VendorModelValue = {
    VENDOR_MODEL_UNSPECIFIED: 0,
    VENDOR_MODEL_OPEN_AI_REALTIME: 1,
    VENDOR_MODEL_DEEPGRAM: 2,
};
